import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './Popup.css';
import Button from '../Button';
import Icon from '../Icon';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import popupBehaviour from './popupBehaviour';

class Popup extends React.Component {
  render() {
    const { devicetype } = this.props;
    const PopupOverviewClose = 
      devicetype === 'superior'
      ? cx(s.PopupOverview_close, s.close_spirotech) 
      : cx(s.PopupOverview_close);

    const { className } = this.props;
    const wrappedStyle = cx(s.Popup, className);
    return (
      <div className={s.Popup_wrapper}>
        <div className={s.Popup_overlay} onClick={this.props.onClose} />
        <div className={wrappedStyle}>
          <div className={cx(s.Popup_close, s.u_cf)}>
            <button
              type="button"
              className={PopupOverviewClose}
              onClick={this.props.onClose}
            >
               <Icon iconName={"odrzuc"} size={20}/>
            </button>
          </div>
            {this.props.children}
        </div>
      </div>
    );
  }
}

Popup.propTypes = {
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
  showExternalClose: PropTypes.bool,
  children: PropTypes.node,
};

Popup.defaultProps = {
  devicetype: '',
}


export default popupBehaviour(withStyles(s)(Popup));



// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js